import { useLoading } from "context/LoadingContext";
import { ToastContext } from "context/ToastContext";
import useDocumentTitle from "hooks/useDocumentTitle";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateGlobalSurgicalPeriodRulesetMutation } from "store/queries/globalSurgicalPeriodRulesets";

import {
  IGlobalSurgicalPeriodFormData,
  INITIAL_GLOBAL_SURGICAL_PERIOD_FORM_DATA,
  GlobalSurgicalPeriodForm,
} from "./components/GlobalSurgicalPeriodForm";

export function CreateGlobalSurgicalPeriodPage() {
  useDocumentTitle("Create Global Surgical Period Rule");
  const navigate = useNavigate();
  const { setIsLoading } = useLoading();
  const { current: toastElement } = useContext(ToastContext);
  const [createMutation, { isLoading }] =
    useCreateGlobalSurgicalPeriodRulesetMutation();
  const [formData, setFormData] = useState<IGlobalSurgicalPeriodFormData>(
    INITIAL_GLOBAL_SURGICAL_PERIOD_FORM_DATA
  );

  const handleSubmit = async () => {
    if (formData.applicability === "SCOPED" && !formData.providerId) return;
    setIsLoading(true);
    try {
      await createMutation({
        groupName: formData.groupName.trim() || null,
        applicability: formData.applicability,
        providerId:
          formData.applicability === "SCOPED" ? formData.providerId : null,
        // CLE-2597 — a FALLBACK rule may name a payer; only a TYPICAL template is scopeless.
        payerId: formData.applicability === "TYPICAL" ? null : formData.payerId,
        lookbackDays: formData.lookbackDays,
        requireGlobalRemark: formData.requireGlobalRemark,
        allowPostopMap: formData.allowPostopMap,
        contractLanguage: formData.contractLanguage.trim() || null,
      }).unwrap();
      toastElement?.show({
        severity: "success",
        summary: "Created!",
        detail: "Global surgical period rule created successfully.",
      });
      navigate("/payer-rules");
    } catch (error: any) {
      toastElement?.show({
        severity: "error",
        summary: "Error",
        detail:
          error?.data?.message ||
          "Failed to create global surgical period rule",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <GlobalSurgicalPeriodForm
      title="Create Global Surgical Period Rule"
      submitLabel="Create Rule"
      formData={formData}
      onChange={setFormData}
      onSubmit={handleSubmit}
      isSubmitting={isLoading}
    />
  );
}
